import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import themeColors from '../../assets/styles/themeColors';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import { variables } from '../../assets/styles/variables';

export const FooterText = styled.a`
  text-decoration: none;
  color: ${themeColors.colorFooterText};
  text-transform: uppercase;
  font-size: ${pxToRem(12)};

  > svg {
    width: ${pxToRem(16)};
    height: ${pxToRem(16)};
    margin-right: ${pxToRem(4)};
    color: currentColor;
  }

  ${mediaBelow(variables.breakpoints.bpXl)} {
    font-size: ${pxToRemMd(11)};
    line-height: 2;
  }
`;

const FooterLink = ({ value, type, text }) => {
  const checkWebsiteUrl = () => {
    if (value) {
      if (value.includes('https://')) {
        return value;
      }

      if (value.includes('http://')) {
        return value;
      }

      return `https://${value}`;
    }
  };

  const prefix = () => {
    switch (type) {
      case 'telephone':
        return `tel:${value}`;

      case 'email':
        return `mailto:${value}`;

      case 'website':
        return checkWebsiteUrl(value);

      default:
        break;
    }
  };

  if (type === 'website') {
    return (
      <FooterText href={prefix()} target="_blank" rel="noopener noreferrer">
        {text || value}
      </FooterText>
    );
  }

  return <FooterText href={prefix()}>{text || value}</FooterText>;
};

FooterLink.propTypes = {
  value: PropTypes.string,
  type: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.shape({}),
  ]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
};

export default FooterLink;
